import { getSystemIcon, SystemIcon } from '@helpers/icons';
import * as React from 'react';
import { FocusRing } from 'react-aria';
import S from './Number.styles';
const Number = React.forwardRef(({ onMinusClick, onPlusClick, minusLabel, plusLabel, ...props }, ref) => {
    return (React.createElement(FocusRing, { focusRingClass: "focus-ring" },
        React.createElement(S.InputWrapper, null,
            React.createElement(S.Button, { disabled: props.disabled ||
                    (!props.value && props.value !== 0) ||
                    parseInt(props.value) <= (props.min ? parseInt(props.min) : 0), onClick: (e) => {
                    e.preventDefault();
                    const value = (parseInt(props.value) - 1).toString();
                    onMinusClick(value);
                }, "aria-label": minusLabel }, getSystemIcon(SystemIcon.Minus)),
            React.createElement(S.Input, { ref: ref, ...props, type: "number", "aria-labelledby": `${props.name}-label` }),
            React.createElement(S.Button, { disabled: props.disabled ||
                    (!props.value && props.value !== 0) ||
                    (!!props.max && parseInt(props.value) >= parseInt(props.max)), onClick: (e) => {
                    e.preventDefault();
                    const value = (parseInt(props.value) + 1).toString();
                    onPlusClick(value);
                }, "aria-label": plusLabel }, getSystemIcon(SystemIcon.Plus)))));
});
Number.displayName = 'Number';
export default Number;
